import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';

export default function StudyGroups() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MARKETING_STUDY_GROUPS,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');    
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({isLoading: true});
            await fetchPage();
            updateProgress({isLoading: false});
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Kingdom Advisors Study Groups | Collaborative Learning</title>
                <meta name="description" content="Join Kingdom Advisors Study Groups for collaborative learning experiences. Network with peers and enhance your ability to integrate faith into practice." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--community-study-groups'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

StudyGroups.isPublic = true;
StudyGroups.getLayout = page => <>{page}</>;
